export default "__VITE_ASSET__DHGel1mt__"